import React from "react";
import { SignedInDto } from "../../services/Auth/dto/signedIn.dto";
import { Reducer, AuthStateType, AuthDispatch } from "./reducer";

export const AuthStateContext = React.createContext<AuthStateType>({
  userInfo: {} as SignedInDto,
});
export const AuthDispatchContext = React.createContext<
  AuthDispatch | undefined
>(undefined);

interface AuthProviderProps {}

type AuthProviderPropsType = React.PropsWithChildren<AuthProviderProps>;

export const AuthProvider: React.FC<AuthProviderPropsType> = ({
  children,
}: AuthProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {});
  return (
    <AuthDispatchContext.Provider value={dispatch}>
      <AuthStateContext.Provider value={state}>
        {children}
      </AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
};

export const useAuthState = () => {
  const state = React.useContext(AuthStateContext);
  return state;
};

export const useAuthDispatch = () => {
  const dispatch = React.useContext(AuthDispatchContext);
  return dispatch;
};
